import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { CashFlowDetailDTO } from "../models/document.model";
import { ReceiptListSTS } from "../models/receipt.model";
import { LinqFilterDTO,LinqFilterType,LinqPredicateDTO } from '../models/linqPredicate.model';
import { FilterService } from './filter.service';
@Injectable({
  providedIn: 'root'
})

export class ReceiptService {

  constructor(private http: HttpClient,private filterService: FilterService) {
  }

  deleteAllReceiptsByID(id: number,idDueInvoice: number= 0, isPassive: boolean = false, ExludeNamirialPay: boolean = true): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + "/Receipt/DeleteAllReceiptsByID/" + id + "/" + idDueInvoice + "/" + isPassive + "/" + ExludeNamirialPay).toPromise();
  }

  saveListReceipts(cashFlowDetails: CashFlowDetailDTO): Promise<any> {    
    return this.http.post<any>(environment.apiFullUrl + "/Receipt/SaveListReceipts", cashFlowDetails).toPromise();
  }

  RF19ReceiptCheckLimit(cashFlowDetails: CashFlowDetailDTO, fk_company: number): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + "/Receipt/RF19ReceiptCheckLimit/" + fk_company, cashFlowDetails).toPromise();
  }
  getReceiptsSTS(linqPredicate: Array<LinqPredicateDTO> = []): Promise<Array<ReceiptListSTS>> {

    if (linqPredicate == null || linqPredicate == undefined)
      linqPredicate = new Array<LinqPredicateDTO>();

    let fk_companyPredicate: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company");

    //Lo accoda agli eventuali filtri che arrivano come parametri
    let linqPredicates: Array<LinqPredicateDTO> = fk_companyPredicate.concat(linqPredicate);

    return this.http.post<Array<ReceiptListSTS>>(environment.apiFullUrl + '/Receipt/GetSTSReceipts', linqPredicates).toPromise();
  }
}
